import React, { useCallback } from "react";
import {
  graphql,
  loadQuery,
  useLazyLoadQuery,
  useRelayEnvironment,
} from "react-relay";
import { WTCS_SELECT_ROUTINE_QUERY } from "./WTCSSelectRoutine";
import { WTCSStackScreenProps } from "./WTCSStack";

import {
  AHSeparator,
  AHTeamIconCircleRelay,
  ListItem,
  useBoxStyle,
} from "arkh";
import { keyExtractorId } from "../../../WidgetAdd/utils/keyExtractors";

import { FlatList } from "react-native";
import { WTCSSelectTeamQuery } from "./__generated__/WTCSSelectTeamQuery.graphql";
import { WTCSSelectRoutineQuery } from "./__generated__/WTCSSelectRoutineQuery.graphql";

export function WTCSSelectTeams(
  props: WTCSStackScreenProps<"WTCSSelectTeams">
) {
  const env = useRelayEnvironment();

  const data = useLazyLoadQuery<WTCSSelectTeamQuery>(
    graphql`
      query WTCSSelectTeamQuery {
        store {
          publicTeams {
            id
            name
            color
            ...AHTeamIconCircle
          }
        }
      }
    `,
    {}
  );

  const onPressItem = useCallback(
    (teamId: string) => {
      const qr = loadQuery<WTCSSelectRoutineQuery>(
        env,
        WTCS_SELECT_ROUTINE_QUERY,
        {
          teamId,
        },
        {
          fetchPolicy: "store-and-network",
        }
      );
      props.navigation.navigateDeprecated("WTCSSelectRoutine", { query: qr });
    },
    [env, props.navigation]
  );

  const teams = data.store.publicTeams ?? [];

  type Item = (typeof teams)[number];

  const renderItem = useCallback(
    ({ item, index }: { item: Item; index: number }) => (
      <ListItem
        border="border-primary"
        isFirst={index === 0}
        isLast={index === (teams.length ?? 0) - 1}
        onPress={() => onPressItem(item.id)}
        right={<ListItem.NavArrow />}
        left={<AHTeamIconCircleRelay team={item} size="smallMedium" />}
      >
        <ListItem.Title>{item.name}</ListItem.Title>
      </ListItem>
    ),
    [onPressItem, teams.length]
  );

  const contentContainerStyle = useBoxStyle({
    space: "medium",
    spaceTop: "medium",
  });

  return (
    <FlatList
      style={{ flex: 1 }}
      data={teams}
      renderItem={renderItem}
      ItemSeparatorComponent={AHSeparator}
      contentContainerStyle={contentContainerStyle}
      keyExtractor={keyExtractorId}
    />
  );
}
